import { defineMessages } from 'react-intl';

export default defineMessages({
  sourceError: {
    id: 'overlay.source-error',
    defaultMessage: 'Video cannot be played',
  },
  buyFrom: {
    id: 'overlay.buy-from',
    defaultMessage: 'Buy from {price}',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/overlay/translations.js